// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2244":"f0a5833028d6efdc","7234":"90efce4bf4f99a5f"}[chunkId] + ".js";
};